import {styled} from "@mui/material/styles";
import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import configs from "../../../../utils/config.json";
import {Alert, Button, CircularProgress, Container, Grid, Snackbar} from "@mui/material";
import styles from "../../assets/css/user.module.scss";
import {TextField} from "../../../../components/subComponents/TextField";
import {Editor} from "@tinymce/tinymce-react";
import LoadingButton from "../../../../components/subComponents/LoadingButton";
import {ServiceApi} from "../../../../utils/ServiceApi";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const Input = styled('input')({
    display: 'none',
});
const Service = (props) => {
    const navigate = useNavigate();
    const ref = useRef();
    const params = useParams();

    const [sending, setSending] = useState(false);
    const [imageLoading, setImageLoading] = useState(false);
    const editorRef = useRef(null);
    const [openSnackBar1, setOpenSnackBar1] = React.useState(false);
    const [message, setMessage] = useState('');
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };
    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const sendDataToServer = async () => {
        setSending(true);

        if (params.id) {
            const update = async () => {
                let fd = new FormData();
                fd.append("payload", JSON.stringify({
                    title: title,
                    description: description,
                    body: editorRef.current.getContent()
                }));
                if (ref.current.files.length)
                    fd.append("video", ref.current.files[0]);
                await ServiceApi.updateServices(fd,params.id,
                    async (result) => {
                        handleClickSnackBar1("خدمت بروزرسانی شد.");
                        await sleep(3000);
                        setSending(false);
                        navigate("/admin/service");
                    },
                    (error) => {
                        setSending(false);

                    });
            }
            await update();
        } else {
            const insert = async () => {
                let fd = new FormData();
                fd.append("payload", JSON.stringify({
                    title: title,
                    description: description,
                    body: editorRef.current.getContent()
                }));
                if (ref.current.files.length)
                    fd.append("video", ref.current.files[0]);
                await ServiceApi.insertServices(fd,
                    async (result) => {
                        handleClickSnackBar1("خدمت افزوده شد.");
                        await sleep(3000);
                        setSending(false);
                        navigate("/admin/service");
                    },
                    (error) => {
                        setSending(false);

                    });
            }
            await insert();
        }

    }
    useEffect(() => {
        if (params.id) {
            (async () => {
                await ServiceApi.getService(params.id, (result) => {
                    setTitle(result.data.title);
                    setDescription(result.data.description);
                    setTitle(result.data.title);
                    editorRef.current.setContent(result.data.body);
                    document.getElementById("video").setAttribute("src", `${configs.server.Storage}/${result.data.video}`);

                }, (error) => {
                });
            })();
        }
    }, []);
    return <div>
        <Container maxWidth={"md"}>
            <Grid container spacing={8}>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <div className={styles.inputContainer}>
                                <TextField label="عنوان" variant="outlined"
                                           value={title}
                                           onChange={e => {
                                               setTitle(e.target.value)
                                           }}
                                           fullWidth
                                />
                            </div>
                        </Grid>


                        <Grid item xs={12}>
                            <div className={styles.inputContainer}>

                                <TextField label="شرح" variant="outlined"
                                           multiline
                                           rows={5}
                                           value={description}
                                           onChange={e => {
                                               setDescription(e.target.value)
                                           }}
                                           fullWidth

                                />
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <div style={{display: "flex", flexDirection: "row"}}>
                                <div style={{
                                    width: "50%",
                                    borderRadius: 15,
                                    margin: 15,
                                    overflow: "hidden",
                                    position: "relative",
                                    height: 300
                                }}>
                                    <video id={"video"}
                                         style={{
                                             width: "100%",
                                             position: "absolute",
                                             top: 0,
                                             height: "100%",
                                             zIndex: 1
                                         }}
                                         src={'https://ndb-soft.com/wp-content/uploads/2020/06/placeholder.png'}
                                    muted
                                    controls/>
                                    <div style={{
                                        top: 130,
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        position: "absolute",
                                        zIndex: 2
                                    }}>
                                        {imageLoading && <CircularProgress/>}
                                    </div>
                                </div>


                                <label htmlFor="img"
                                       style={{
                                           display: "flex",
                                           flexDirection: "column",
                                           justifyContent: "center",
                                           width: "50%"
                                       }}>
                                    <Input  accept="video/mp4,video/x-m4v,video/*"
                                            type="file"  ref={ref} id={"img"}
                                           onChange={e => {
                                               setImageLoading(true);
                                               let files = e.target.files; // FileList object

                                               // use the 1st file from the list
                                               let f = files[0];

                                               let reader = new FileReader();
                                               // Closure to capture the file information.
                                               reader.onload = (function (theFile) {
                                                   return function (e) {
                                                       document.getElementById("video").setAttribute("src", this.result);
                                                       document.getElementById("video").play();
                                                       setImageLoading(false);
                                                       console.log("image loaded!!")
                                                   };
                                               })(f);

                                               // Read in the image file as a data URL.
                                               reader.readAsDataURL(f);
                                           }}/>
                                    <Button variant="contained" component="span">
                                        آپلود ویدئو‍
                                    </Button>
                                </label>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <Editor
                                tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                                onInit={(evt, editor) => editorRef.current = editor}
                                initialValue=''
                                init={{
                                    selector: 'textarea#full-featured',
                                    plugins: 'preview powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap pagebreak nonbreaking anchor tableofcontents insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker editimage help formatpainter permanentpen pageembed charmap tinycomments mentions quickbars linkchecker emoticons advtable export footnotes mergetags autocorrect',
                                    tinydrive_token_provider: 'qd5j6711qidg02ipi9ojw02n9ip5vvraiddhuc107rjkhp3x',
                                    tinydrive_dropbox_app_key: 'YOUR_DROPBOX_APP_KEY',
                                    tinydrive_google_drive_key: 'YOUR_GOOGLE_DRIVE_KEY',
                                    tinydrive_google_drive_client_id: 'YOUR_GOOGLE_DRIVE_CLIENT_ID',
                                    mobile: {
                                        plugins: 'preview powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap pagebreak nonbreaking anchor tableofcontents insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker help formatpainter pageembed charmap mentions quickbars linkchecker emoticons advtable footnotes mergetags autocorrect'
                                    },
                                    menu: {
                                        tc: {
                                            title: 'Comments',
                                            items: 'addcomment showcomments deleteallconversations'
                                        }
                                    },
                                    menubar: 'file edit view insert format tools table tc help',
                                    toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment | footnotes | mergetags',
                                    toolbar_sticky: true,
                                    autosave_ask_before_unload: true,
                                    autosave_interval: '30s',
                                    autosave_prefix: '{path}{query}-{id}-',
                                    autosave_restore_when_empty: false,
                                    autosave_retention: '2m',
                                    image_advtab: true,
                                    link_list: [
                                        {title: 'My page 1', value: 'https://www.tiny.cloud'},
                                        {title: 'My page 2', value: 'http://www.moxiecode.com'}
                                    ],
                                    image_list: [
                                        {title: 'My page 1', value: 'https://www.tiny.cloud'},
                                        {title: 'My page 2', value: 'http://www.moxiecode.com'}
                                    ],
                                    image_class_list: [
                                        {title: 'None', value: ''},
                                        {title: 'Some class', value: 'class-name'}
                                    ],
                                    importcss_append: true,
                                    templates: [
                                        {
                                            title: 'New Table',
                                            description: 'creates a new table',
                                            content: '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>'
                                        },
                                        {
                                            title: 'Starting my story',
                                            description: 'A cure for writers block',
                                            content: 'Once upon a time...'
                                        },
                                        {
                                            title: 'New list with dates',
                                            description: 'New List with dates',
                                            content: '<div class="mceTmpl"><span class="cdate">cdate</span><br><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>'
                                        }
                                    ],
                                    template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
                                    template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
                                    height: 600,
                                    image_caption: true,
                                    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                                    noneditable_class: 'mceNonEditable',
                                    toolbar_mode: 'sliding',
                                    spellchecker_ignore_list: ['Ephox', 'Moxiecode'],
                                    tinycomments_mode: 'embedded',
                                    content_style: '.mymention{ color: gray; }',
                                    contextmenu: 'link image editimage table configurepermanentpen',
                                    a11y_advanced_options: true,

                                    /*
                                    The following settings require more configuration than shown here.
                                    For information on configuring the mentions plugin, see:
                                    https://www.tiny.cloud/docs/tinymce/6/mentions/.
                                    */
                                    mentions_selector: '.mymention',

                                    mentions_item_type: 'profile',
                                    autocorrect_capitalize: true,
                                    mergetags_list: [
                                        {
                                            title: 'Client',
                                            menu: [
                                                {
                                                    value: 'Client.LastCallDate',
                                                    title: 'Call date'
                                                },
                                                {
                                                    value: 'Client.Name',
                                                    title: 'Client name'
                                                }
                                            ]
                                        },
                                        {
                                            title: 'Proposal',
                                            menu: [
                                                {
                                                    value: 'Proposal.SubmissionDate',
                                                    title: 'Submission date'
                                                }
                                            ]
                                        },
                                        {
                                            value: 'Consultant',
                                            title: 'Consultant'
                                        },
                                        {
                                            value: 'Salutation',
                                            title: 'Salutation'
                                        }
                                    ]
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Button color="error" onClick={() => {
                        navigate(-1);
                    }}>
                        انصراف
                    </Button>

                    <LoadingButton
                        loading={sending}
                        loadingPosition="end"
                        variant={'text'}
                        color="primary"
                        component="button"
                        onClick={() => {
                            sendDataToServer();
                        }}
                    >
                        ثبت
                    </LoadingButton>

                </Grid>
            </Grid>

        </Container>

        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert onClose={handleCloseSnackBar1} severity="info"
                   action={null

                   }
                   className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>
    </div>;
}
export default Service;